// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HhsPrescriber {
    static getAttributeTypeMap() {
        return HhsPrescriber.attributeTypeMap;
    }
}
HhsPrescriber.discriminator = undefined;
HhsPrescriber.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "deaNumber",
        "baseName": "deaNumber",
        "type": "string"
    },
    {
        "name": "stateLicenseId",
        "baseName": "stateLicenseId",
        "type": "string"
    },
    {
        "name": "ptan",
        "baseName": "ptan",
        "type": "string"
    },
    {
        "name": "facilityPhoneNumber",
        "baseName": "facilityPhoneNumber",
        "type": "string"
    },
    {
        "name": "facilityFaxNumber",
        "baseName": "facilityFaxNumber",
        "type": "string"
    },
    {
        "name": "facilityAddress",
        "baseName": "facilityAddress",
        "type": "HhsAddress"
    },
    {
        "name": "facilityName",
        "baseName": "facilityName",
        "type": "string"
    }
];
//# sourceMappingURL=hhsPrescriber.js.map